import isLocalhost from './IsLocalhost';

const currentDomain = window.location.hostname.match(/([^.]+\.)?[^.]+\.\w{2,10}$/);

export default isLocalhost || (currentDomain && `.${currentDomain[0]}`);
